import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { showModal } from "./modal";
import { UPDATE_DATA, actionHandler } from "./updateData";


// ------------------------------------
// Constants
// ------------------------------------
export const GET_AITOOL_START = "GET_AITOOL_START";
export const GET_AITOOL_FAILURE = "GET_AITOOL_FAILURE";
export const GET_AITOOL_SUCCESS = "GET_AITOOL_SUCCESS";
export const RETURN_AITOOL_INITIAL_STATE = "RETURN_AITOOL_INITIAL_STATE";


export function getAiQuery(role, instruction, content) {
  return (dispatch) => {
    dispatch({ type: GET_AITOOL_START });

    const headers = {
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Role: role,
        Instruction: instruction,
        Content: content,
      }),
    };

    return fetch(`${globals.apiUrl}/Ai`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_AITOOL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_AITOOL_SUCCESS, 
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_AITOOL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function returnInitialState() {
  return {
    type: RETURN_AITOOL_INITIAL_STATE,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.aiTool
      ? state
      : actionHandler(state, action),
  [RETURN_AITOOL_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_AITOOL_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_AITOOL_SUCCESS]: (state, action) => {
    const recordInfo = action.payload.json;
    return {
      ...state,
      reply: recordInfo.Reply,
      formDataValue: {
        ...state.formDataValue,
        AI: {
          ...state.formDataValue.AI,
          reply: recordInfo.Reply,
        },
      },
    };    
  },
  [GET_AITOOL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {},
  formDataValue: {
    AI: {},
  },
};

export default function aiToolReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/aiToolFormData.js